import script from "./TrafficRankList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrafficRankList.vue?vue&type=script&setup=true&lang=js"

import "./TrafficRankList.vue?vue&type=style&index=0&id=c2f669ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2f669ce"]])

export default __exports__